import classNames from "classnames";
import { useRouter } from "next/router";
import { useTranslations } from "next-intl";

import myaccount from "~/components/common/myaccount.module.scss";
import { useFavouriteStore } from "~/contexts/favourite-store";

import LinkWrapper from "../common/link-wrapper";
import PreferredStoreModalWrapper from "../stores/preferred-store-modal-wrapper";
import { getOpeningHours } from "../stores/stores-modal";
import styles from "./stores-card.module.scss";

// used in myaccount dashboard
export default function StoresCard() {
  const t = useTranslations();
  const { preferredStore } = useFavouriteStore();
  const router = useRouter();

  return (
    <div className={myaccount.myaccountCard}>
      <div className={myaccount.myaccountCardHeader}>
        <h2>{t("generic.myaccount.dashboard.myPreferredStore")}</h2>
        <LinkWrapper href="preferred-store">{t("generic.edit")}</LinkWrapper>
      </div>
      <div className={classNames(myaccount.myaccountCardContent, styles.content)}>
        {preferredStore ? (
          <>
            <p className={styles.storeName}>{preferredStore.Name}</p>
            {preferredStore.Address && (
              <p className={styles.storeAddress}>
                {preferredStore.Address.Address1}
                {preferredStore.Address.City ? `, ${preferredStore.Address.City}` : ""}
                {preferredStore.Address.CountryID ? `, ${preferredStore.Address.CountryID}` : ""}
                {preferredStore.Address.PhoneNumber ? (
                  <>
                    {` · `}
                    <a href={`tel:${preferredStore.Address.PhoneNumber}`}>{preferredStore.Address.PhoneNumber}</a>
                  </>
                ) : (
                  ""
                )}
              </p>
            )}
            {getOpeningHours(preferredStore.RegularOpeningHours, router.locale, t("generic.storeOpeningHours"))}
          </>
        ) : (
          <>
            <p>{t("generic.myaccount.dashboard.noPreferredStoreSelected")}</p>
          </>
        )}
        <PreferredStoreModalWrapper buttonClasses={styles.selectStore} />
      </div>
    </div>
  );
}
